import React from 'react';

import { VOID_FUNCTION } from 'constants/index';

import * as S from './TextInputPreview.styles';

export const TextInputPreview = ({
  className,
  editable = true,
  onEdit = VOID_FUNCTION,
  ...rest
}) => {
  return (
    <S.Container className={className}>
      <S.TextInput {...rest} disabled regular />
      {editable && <S.EditButton onClick={onEdit} />}
    </S.Container>
  );
};
